/**
 * Centralized Deal Stage Configuration
 * ====================================
 * Note: The proposed Deal stage names below are provisional and subject to
 * final business approval. Changing a stage name in the future requires
 * modifying this file only, rather than hunting across components.
 */

export const DEAL_STAGES_CONFIG = [
  {
    id: "active_deal",
    label: "Active Deal",
    color: "#86efac",
    bgClass: "status-active-deal",
    order: 1,
    isWon: false,
    isLost: false,
  },
  {
    id: "under_review",
    label: "Under Review",
    color: "#93c5fd",
    bgClass: "status-under-review",
    order: 2,
    isWon: false,
    isLost: false,
  },
  {
    id: "vendor_po",
    label: "Vendor PO",
    color: "#facc15",
    bgClass: "status-vendor-po",
    order: 3,
    isWon: false,
    isLost: false,
  },
  {
    id: "product_confirmation",
    label: "Product Confirmation from Client",
    color: "#fdba74",
    bgClass: "status-product-confirmation-from-client",
    order: 4,
    isWon: false,
    isLost: false,
  },
  {
    id: "client_invoicing",
    label: "Client Invoicing",
    color: "#f472b6",
    bgClass: "status-client-invoicing",
    order: 5,
    isWon: false,
    isLost: false,
  },
  {
    id: "won_close",
    label: "Won Close",
    color: "#22c55e",
    bgClass: "status-won-close",
    order: 6,
    isWon: true,
    isLost: false,
  },
  {
    id: "lost",
    label: "Lost",
    color: "#ef4444",
    bgClass: "status-lost",
    order: 7,
    isWon: false,
    isLost: true,
  },
];

// Standard ordered list of proposed stage labels
export const DEAL_STATUSES = DEAL_STAGES_CONFIG.map((stage) => stage.label);

// Color mapping for stepper & badges with backward-compatible aliases
export const DEAL_STAGE_COLORS = {
  ...DEAL_STAGES_CONFIG.reduce(
    (acc, stage) => ({ ...acc, [stage.label]: stage.color }),
    {}
  ),
  // Legacy aliases
  Open: "#86efac",
  Active: "#86efac",
  "In Progress": "#86efac",
  "Proposal Sent": "#93c5fd",
  Negotiation: "#facc15",
  Won: "#22c55e",
  "Deal Lost": "#ef4444",
};

// CSS class mapping for deal status badges
export const DEAL_STATUS_BADGE_CLASSES = {
  ...DEAL_STAGES_CONFIG.reduce(
    (acc, stage) => ({ ...acc, [stage.label]: stage.bgClass }),
    {}
  ),
  // Legacy aliases
  Open: "status-open",
  Active: "status-active-deal",
  "Proposal Sent": "status-proposal",
  Negotiation: "status-negotiation",
  Won: "status-won",
  "Deal Lost": "status-lost",
};

/**
 * Returns the CSS class for a given deal status.
 */
export const getDealStatusBadgeClass = (status) => {
  if (!status) return "status-default";
  return DEAL_STATUS_BADGE_CLASSES[status] || "status-default";
};

/**
 * Returns the hex color for a given deal stage.
 */
export const getDealStageColor = (stage) => {
  if (!stage) return "#94a3b8";
  return DEAL_STAGE_COLORS[stage] || "#94a3b8";
};
